export default __webpack_public_path__ + "static/media/news3.489ba341.png";